<template>
  <main-layout>
    <template #header>
        <main-header :title="'기본요금제 관리' | translate">
          <template #btn-wrapper>
            <v-btn
              small
              outlined
              color="primary"
              @click.stop="newPlanEdit()"
            >
              <v-icon
                small
              >
                mdi-square-edit-outline
              </v-icon>
              신규
            </v-btn>
          </template>
        </main-header>
      <search-bar
        v-model="searchOptions.searchKeyword"
        :placeholder="'요금제 명 / 비고' | translate"
        style="width: 450px;"
      />
    </template>

    <template #feature />

    <template #toolbar>
      <main-toolbar>
        <search-single-select-box
          v-model="searchOptions.useYn"
          :items="defaultYnOptions"
          :label="'사용여부' | translate"
          style="max-width: 125px;"
          @update:selected="onLoad(1)"
        />
        <!--
        <search-multi-select-box
          v-model="searchOptions.rentalcompanyGroups"
          :items="rentalCompanyGroupOptions"
          :label="'임대업체 그룹' | translate"
          style="max-width: 200px;"
          @update:selected="onFilterChanged"
        />
        -->
      </main-toolbar>
    </template>

    <template #body>
      <main-body>
        <infinity-scroll-table
          :headers="headers"
          :is-loading="isLoading"
          :items="convertItems"
          :items-total-count="dataTotalCount"
          :infinity-scroll="infinityScroll"
          :sort-option="sortOption"
          :page-number="searchOptions.pageNumber"
          :page-length="pageLength"
          :item-numbering="true"
          @on-page-change="e => onLoad(e)"
          @on-click-item="e => onClickItem(e)"
        />
        <v-dialog
          ref="detail-dialog"
          v-model="detailDialogShow"
          width="1000px"
          max-width="1000px"
          persistent
        >
          <base-plan-detail
            v-if="selectedItem"
            :title="!!selectedItem && !!selectedItem.planName ? selectedItem.planName : undefined"
            :item="selectedItem"
            :sub-item-codes="subItemCodes"
            @close="closeDetailDialog"
            @save="onSaveItem"
            @delete="onDeleteItem"
          />
        </v-dialog>
      </main-body>
    </template>
  </main-layout>
</template>

<script>
import MainLayout from "@/components/common/layout/MainLayout";
import MainBody from "@/components/common/layout/MainBody";
import MainToolbar from "@/components/common/layout/MainToolbar";
import MainHeader from "@/components/common/layout/MainHeader";
import {PATH} from "@/constants";
import TotalCodeOptions from "@/assets/options/TotalCodeOptions";
import SearchBar from "@/components/input/new/SearchBar";
import InfinityScrollTable from "../../components/common/newBase/InfinityScrollTable.vue";
import Headers from "../../components/common/newBase/Headers.vue";
import BasePlanDetail from "../../components/payment/BasePlanDetail.vue";
import {DateTime} from "luxon";
import SearchSingleSelectBox from "@/components/input/SearchSingleSelectBox";
import {cloneDeep} from "lodash";
export default {
  name: "BasePlan",
  components: {
    BasePlanDetail,
    // SearchMultiSelectBox,
    InfinityScrollTable,
    MainToolbar,
    MainHeader,
    MainBody,
    MainLayout,
    SearchBar,
    SearchSingleSelectBox
  },
  // extends: Headers,
  mixins: [TotalCodeOptions, Headers],
  data() {
    return {
      headers: [],
      searchOptions: {
        searchKeyword: undefined,
        useYn: 'Y',
        pageNumber: 1,
        pageSize: 30,
      },
      sortOption: {
        sortBy: ['planId'],
        sortDesc: ['true'],
      },
      infinityScroll: false,
      subItemCodes: [],
      items: [],
      dataTotalCount: 0,
      isLoading: false,
      isSaveLoading: false,

      detailDialogShow: false,
      selectedItem: undefined
      //
      // rentalCompanyGroupOptions: [],
    }
  },

  computed: {
    pageLength() {
      if (!this.dataTotalCount) return 1
      return Math.ceil(this.dataTotalCount / this.searchOptions.pageSize)
    },
    convertItems() {
      return this.items.map(item => {
        const {
          planItems,
          ...others
        } = item

        let subItems = {}

        this.subItemCodes?.forEach(code => {
          const findPlanItem = planItems.find(pItem => pItem.codeKey === code.codeKey)
          subItems[`${code.codeKey}_standardCnt`] = findPlanItem?.standardCnt
          subItems[`${code.codeKey}_addCnt`] = findPlanItem?.addCnt
          subItems[`${code.codeKey}_addFee`] = findPlanItem?.addFee
        })

        return {
          ...others,
          ...subItems,
        }
      })
    },
  },

  watch: {
    'searchOptions.searchKeyword': {
      handler(newValue, oldValue) {
        this.onLoad(1)
      }
    },
  },


  async mounted() {
    this.loadDefaultYnOptions()
    await this.loadCodes()
    this.onLoad(1)
    this.setHeaders()
  },

  methods: {
    /**
     * 목록에 출력할 Header를 세팅
     */
    setHeaders() {
      this.headers.splice(0, this.headers.length)
      this.headers.push(...this.basePlanHeaders)
      this.subItemCodes?.forEach(e => {
        this.headers.push(
          {
            text: e.codeValue,
            child: [
              {
                text: '기본제공',
                key: `${e.codeKey}_standardCnt`,
                align: 'right',
                width: '60px',
                sortable: false,
                read: (item, v) => v || v === 0 ? Number(v).toLocaleString() : '<span style="color: #aaa">N/A</span>'
              },
              {
                text: '추가기준',
                key: `${e.codeKey}_addCnt`,
                align: 'right',
                width: '60px',
                sortable: false,
                read: (item, v) => v || v === 0 ? Number(v).toLocaleString() : '<span style="color: #aaa">N/A</span>'
              },
              {
                text: '추가료',
                key: `${e.codeKey}_addFee`,
                align: 'right',
                width: '60px',
                sortable: false,
                read: (item, v) => v || v === 0 ? Number(v).toLocaleString() + ' 원' : '<span style="color: #aaa">N/A</span>'
              },
            ],
          }
        )
      })

      this.headers.push(...[
        {
          text: '등록자',
          key: 'registerName',
          align: 'center',
          width: '80px',
          sortable: false,
        },
        {
          text: '등록일시',
          key: 'regDatetime',
          align: 'center',
          width: '80px',
          sortable: false,
          read: (item) => {
            if (!!item.regDatetime)
              return DateTime.fromISO(item.regDatetime).toFormat('yyyy-MM-dd<br />HH:mm')
            return '-'
          }
        },
        {
          text: '수정자',
          key: 'updaterName',
          align: 'center',
          width: '80px',
          sortable: false,
        },
        {
          text: '수정일시',
          key: 'updDatetime',
          align: 'center',
          width: '80px',
          sortable: false,
          read: (item) => {
            if (!!item.updDatetime)
              return DateTime.fromISO(item.updDatetime).toFormat('yyyy-MM-dd<br />HH:mm')
            return '-'
          }
        },
      ])
    },

    /**
     * 요금제의 하위 설정 값을 조회
     * @return {Promise<void>}
     */
    async loadCodes() {
      this.subItemCodes.splice(0, this.subItemCodes.length)
      const res = await this.$request(PATH.MPS_PLAN.SUB_CODE_LIST)
        .setObject({})
        .catch(e => {
          console.error(e)
        })
        .enqueue()
      this.subItemCodes.push(...res.data)
    },

    /**
     * 페이지 세팅 및 목록 조회 함수 호출
     * @param pageNumber
     */
    onLoad(pageNumber) {
      this.searchOptions.pageNumber = pageNumber
      if (!this.infinityScroll || pageNumber === 1)
        this.items.splice(0, this.items.length)
      this.loadData()
    },

    /**
     * 목록 조회
     * @return {Promise<void>}
     */
    async loadData() {
      if (this.isLoading) return
      this.isLoading = true
      const res = await this.$request(PATH.MPS_PLAN.BASE_LIST)
        .setObject(
          {...this.searchOptions, ...this.sortOption}
        )
        .catch(e => {
          console.error(e)
          this.isLoading = false
        })
        .enqueue()
      this.items.push(...res.data)
      this.dataTotalCount = res.dataTotalCount
      this.isLoading = false
    },

    /**
     * 목록 Item 클릭
     * @param item
     */
    onClickItem(item) {
      this.selectedItem = this.items?.find(e => e.planId === item.planId) || undefined
      if (!this.selectedItem)
        return alert('Error!')
      this.detailDialogShow = true
    },

    /**
     * 신규 버튼 클릭 이벤트 처리
     */
    newPlanEdit() {
      const newItem = {
        planId: undefined,
        planName: '신규 요금제',
        baseFee: 0.0,
        useYn: 'Y',
        deleteYn: 'N',
        planItems: []
      }
      this.subItemCodes.forEach(e => {
        const subItem = {
          itemName: e.codeValue,
          codeKey: e.codeKey,
          standardCnt: 0,
          addCnt: 0,
          addFee: 0.00,
          remark: '',
          useYn: 'Y',
          deleteYn: 'N',
        }
        newItem.planItems.push(subItem)
      })

      this.selectedItem = newItem
      this.detailDialogShow = true
    },

    /**
     * 상세 다이얼로그 닫기
     */
    closeDetailDialog(){
      this.selectedItem = undefined
      this.detailDialogShow = false
    },

    /**
     * 신규 아이템 저장 or 기존 아이템 저장(삭제)
     * @param item
     * @return {Promise<void>}
     */
    async onSaveItem(item){
      try {
        if (this.isSaveLoading)
          return this.$toasted.error('처리중인 요청이 있습니다.')

        if (!confirm('저장하시겠습니까?'))
          return
        this.isSaveLoading = true

        const saveValidItem = this.convertSaveValidItem(item)

        if (!saveValidItem) {
          this.isSaveLoading = false
          return
        }

        const res = await this.$request(PATH.MPS_PLAN.BASE_INS_OR_UPD)
          .setObject(
            saveValidItem
          )
          .catch(e => {
          })
          .enqueue()
        this.isSaveLoading = false
        if (res || res === 0) {
          this.$toasted.success('저장했습니다.')
          this.closeDetailDialog()
          this.onLoad(1)
        }
      } catch (e) {
        this.$toasted.error('처리 중 문제가 발생하였습니다.')
      } finally {
        this.isSaveLoading = false
      }
    },

    /**
     * 삭제 버튼 클릭 이벤트 처리
     * @param item
     */
    onDeleteItem(item) {
      if (!confirm('삭제 하시겠습니까?')){
        return
      }
      item.deleteYn = 'Y'
      this.onSaveItem(item)
    },

    convertSaveValidItem(item) {
      try {
        let invalidMessage
        let cloneItems = cloneDeep(item)
        console.log('cloneItems -> ', cloneItems)
        cloneItems.baseFee = cloneItems.baseFee.toString().replace(/[^0-9]/g, "");


        if (!cloneItems.planName || cloneItems.planName.trim() === '' ) {
          invalidMessage = '요금제 명은 필수 입력사항 입니다.'
        } else if (Number(cloneItems.baseFee || 0) <= 0) {
          invalidMessage = '기본료가 유효하지 않습니다.'
        }

        cloneItems.planItems

        if (invalidMessage) {
          this.$toasted.error(invalidMessage)
          return false
        }

        return cloneItems

      } catch (e) {
        console.error(e)
        this.$toasted.error('유효하지 않은 값이 존재합니다.')
        return false
      }
    },
  },
}
</script>

<style scoped>
.search-keyword-input {
  width: 250px;

}
</style>
